/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Metadata for a single SAP HANA instance.
*/
export class SapHanaInstance {
  /**
  * SAP System ID.
  */
  'sid'?: string;
  /**
  * Instance number.
  */
  'instanceNumber'?: string;
  /**
  * SAP HANA version.
  */
  'version'?: string;
  /**
  * Whether this is an express edition.
  */
  'isExpress'?: boolean;
  /**
  * Whether this instance is sharded.
  */
  'isSharded'?: boolean;
  /**
  * Whether this instance is replicated.
  */
  'isReplicated'?: boolean;
  /**
  * Whether this is the primary instance.
  */
  'isPrimary'?: boolean;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "sid",
      "baseName": "sid",
      "type": "string",
      "format": ""
    },
    {
      "name": "instanceNumber",
      "baseName": "instanceNumber",
      "type": "string",
      "format": ""
    },
    {
      "name": "version",
      "baseName": "version",
      "type": "string",
      "format": ""
    },
    {
      "name": "isExpress",
      "baseName": "isExpress",
      "type": "boolean",
      "format": ""
    },
    {
      "name": "isSharded",
      "baseName": "isSharded",
      "type": "boolean",
      "format": ""
    },
    {
      "name": "isReplicated",
      "baseName": "isReplicated",
      "type": "boolean",
      "format": ""
    },
    {
      "name": "isPrimary",
      "baseName": "isPrimary",
      "type": "boolean",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return SapHanaInstance.attributeTypeMap;
  }

  public constructor() {
  }
}

